<template>
  <!-- This will be modified based on the request submitted, either the request will come from PLA or SFGTA -->
  <div class="page-view">
    <div class="component">
      <p class="h4 heading">
        Thank you! Your completed registration form has been successfully submitted!
        <span class="fa fa-check-circle text-success fa-lg"></span>
      </p>
      <h5 id="refnumber">
        Please save this reference number in case you need to contact us: <span>{{ referenceNumber }}</span>
      </h5>
      <p><b>What will happen next?</b></p>

      <p>
        Your request has been routed to the GE Aviation business team for processing. We will review your form and
        contact you if any additional information or clarification is required. Once we have completed the processing of
        your requesting changes, you can expect a revised agreement to be sent for signatures within 5-7 business days.
      </p>

      <div v-if="isSnecmaSafranUser">
        <p class="help-text">
          If you have any questions regarding the status of your request, please contact CFM Support via one of the
          following methods:
        </p>
        <cfm-fleet-support-team />
      </div>
      <div v-else>
        <p class="help-text">
          If you have any questions regarding the status of your request, please contact GE Fleet Support via one of the
          following methods:
        </p>
        <ge-fleet-support-team />
      </div>
      <div class="action-btns"><button type="submit" class="btn btn-sm btn-primary" @click="back">Close</button></div>
    </div>
  </div>
</template>
<script>
import geFleetSupportTeam from "@/mycfm/components/GeFleetSupportTeam";
import cfmFleetSupportTeam from "@/mycfm/components/CfmFleetSupportTeam";
import { mapState } from "vuex";

export default {
  components: {
    geFleetSupportTeam,
    cfmFleetSupportTeam
  },
  data() {
    return {
      isSnecmaSafranUser: false
    };
  },
  computed: {
    ...mapState("product", ["referenceNumber", "saveDraft"])
  },
  created() {
    if (!this.referenceNumber) {
      this.back();
    }
  },
  beforeDestroy() {
    this.back();
  },
  methods: {
    back() {
      let isSFGTA = this.$route.path.includes("sfgta-agreement") || this.$route.path.includes("sfgtaSuccess");
      if (isSFGTA) {
        this.$router.push("/sfgta-agreement");
      } else {
        this.$router.push("/");
      }
      window.location.reload();
    }
  }
};
</script>
<style lang="less" scoped>
.component {
  padding-left: 20px;
  padding-right: 20px;
}

#refnumber {
  font-size: 1.8rem;
  margin: 25px 0;

  span {
    font-weight: bold;
    color: green;
  }
}
</style>
